/* StalkMaster kits and setup finder.
   - [data-sm-kit]: a kit card (snippets/sm-kit-card.liquid). Resolves each product's variant from
     its pickers, keeps the kit total up to date and adds the whole kit to the cart in one request,
     then refreshes and opens the cart drawer.
   - [data-sm-tabs]: the temperature tabs of sections/sm-temperature-kits.liquid.
   - [data-sm-finder]: the 3-question finder of sections/sm-setup-finder.liquid. */
(function () {
  if (window.SmKits) return;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function money(cents) {
    var cur = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: cur }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2);
    }
  }

  function refreshCart(cart, source) {
    try {
      if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
        window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: source, cartData: cart });
      }
    } catch (e) {}
    document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { cart: cart } }));
    var drawer = document.querySelector('sugar-cart-drawer');
    if (!drawer) {
      window.location.href = root + 'cart';
      return Promise.resolve(cart);
    }
    var refreshed;
    try { refreshed = drawer.refresh && drawer.refresh(); } catch (e) {}
    return Promise.resolve(refreshed).catch(function () {}).then(function () {
      try { drawer.open && drawer.open(); } catch (e) {}
      return cart;
    });
  }

  /* ---------- Kit card ---------- */

  function Kit(el) {
    this.el = el;
    this.btn = el.querySelector('[data-sm-kit-add]');
    this.label = el.querySelector('[data-sm-kit-label]');
    this.msg = el.querySelector('[data-sm-kit-msg]');
    this.totalEl = el.querySelector('[data-sm-kit-total]');
    this.tierEl = el.querySelector('[data-sm-kit-tier]');
    this.tiers = [];
    if (this.tierEl) {
      this.tiers = (this.tierEl.getAttribute('data-tiers') || '').split(',').map(function (pair) {
        var bits = pair.split(':');
        return { at: Math.round(parseFloat(bits[0]) * 100), pct: parseFloat(bits[1]) };
      }).filter(function (x) { return x.at > 0 && x.pct > 0; }).sort(function (a, b) { return a.at - b.at; });
    }
    this.items = Array.prototype.map.call(el.querySelectorAll('[data-sm-kit-item]'), function (li) {
      var json = li.querySelector('[data-sm-kit-variants]');
      var variants = [];
      try { variants = JSON.parse(json.textContent); } catch (e) {}
      return {
        li: li,
        name: (li.querySelector('.sm-kit__name') || {}).textContent || '',
        variants: variants,
        selects: Array.prototype.slice.call(li.querySelectorAll('[data-sm-kit-opt]')),
        priceEl: li.querySelector('[data-sm-kit-price]'),
        thumb: li.querySelector('[data-sm-kit-thumb]'),
        optional: li.hasAttribute('data-optional'),
        on: !li.hasAttribute('data-optional'),
        toggle: li.querySelector('[data-sm-kit-toggle]')
      };
    });
    var self = this;
    this.items.forEach(function (item) {
      item.selects.forEach(function (s) {
        s.addEventListener('change', function () {
          s.classList.remove('is-missing');
          if (item.optional && !item.on) self.setOn(item, true);
          else self.update();
        });
      });
      if (item.toggle) item.toggle.addEventListener('click', function () { self.setOn(item, !item.on); });
    });
    if (this.btn) this.btn.addEventListener('click', function () { self.add(); });
    this.update();
  }

  Kit.prototype.setOn = function (item, on) {
    item.on = !!on;
    item.li.classList.toggle('is-on', item.on);
    if (item.toggle) item.toggle.setAttribute('aria-checked', item.on ? 'true' : 'false');
    if (!item.on) item.selects.forEach(function (s) { s.classList.remove('is-missing'); });
    this.update();
  };

  Kit.prototype.resolve = function (item) {
    if (!item.selects.length) return item.variants[0] || null;
    var vals = item.selects.map(function (s) { return s.value; });
    if (vals.indexOf('') !== -1) return null;
    for (var i = 0; i < item.variants.length; i++) {
      var v = item.variants[i];
      var ok = true;
      for (var j = 0; j < vals.length; j++) {
        if (v.o[Number(item.selects[j].getAttribute('data-sm-kit-opt'))] !== vals[j]) { ok = false; break; }
      }
      if (ok) return v;
    }
    return null;
  };

  Kit.prototype.partial = function (item) {
    var vals = item.selects.map(function (s) { return s.value; });
    for (var i = 0; i < item.variants.length; i++) {
      var v = item.variants[i];
      var ok = true;
      for (var j = 0; j < vals.length; j++) {
        if (vals[j] && v.o[Number(item.selects[j].getAttribute('data-sm-kit-opt'))] !== vals[j]) { ok = false; break; }
      }
      if (ok) return v;
    }
    return null;
  };

  Kit.prototype.update = function () {
    var total = 0;
    var self = this;
    this.items.forEach(function (item) {
      var v = self.resolve(item);
      var price = v ? v.p : (item.variants[0] ? item.variants[0].p : 0);
      if (item.on) total += price;
      if (item.priceEl) item.priceEl.textContent = (item.optional ? '+ ' : '') + money(price);
      var shown = v || self.partial(item);
      if (item.thumb && shown && shown.i && item.thumb.getAttribute('src') !== shown.i) item.thumb.setAttribute('src', shown.i);
      item.li.classList.toggle('is-unavailable', !!(v && !v.a));
    });
    if (this.totalEl) this.totalEl.textContent = money(total);
    this.updateTier(total);
  };

  Kit.prototype.updateTier = function (total) {
    var el = this.tierEl;
    if (!el || !this.tiers.length) return;
    var active = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || '';
    if (active && active !== el.getAttribute('data-currency')) { el.hidden = true; return; }
    var reached = null, next = null;
    this.tiers.forEach(function (t) { if (total >= t.at) reached = t; else if (!next) next = t; });
    var html;
    if (!reached) html = 'Add <strong>' + money(next.at - total) + '</strong> more to get <strong>' + next.pct + '% off</strong> your order.';
    else if (next) html = '<strong>' + reached.pct + '% off</strong> applied at checkout. Add ' + money(next.at - total) + ' more for ' + next.pct + '% off.';
    else html = '<strong>' + reached.pct + '% off</strong> your order, applied automatically at checkout.';
    el.innerHTML = html;
    el.hidden = false;
  };

  Kit.prototype.say = function (text, isError) {
    if (!this.msg) return;
    this.msg.textContent = text || '';
    this.msg.classList.toggle('is-error', !!isError);
  };

  Kit.prototype.add = function () {
    var self = this;
    var missing = [];
    var unavailable = [];
    var lines = [];
    this.items.forEach(function (item) {
      if (!item.on) return;
      var v = self.resolve(item);
      if (!v) {
        missing.push(item);
        item.selects.forEach(function (s) { if (!s.value) s.classList.add('is-missing'); });
        return;
      }
      if (!v.a) { unavailable.push(item.name.trim()); return; }
      lines.push({ id: v.id, quantity: 1 });
    });
    if (missing.length) {
      this.say('Choose a size for: ' + missing.map(function (m) { return m.name.trim(); }).join(', ') + '.', true);
      var first = missing[0].selects.filter(function (s) { return !s.value; })[0];
      if (first) first.focus();
      return;
    }
    if (unavailable.length) {
      this.say('Not available in that option: ' + unavailable.join(', ') + '. Pick another colour or size.', true);
      return;
    }
    this.say('');
    var original = this.label ? this.label.textContent : '';
    this.btn.disabled = true;
    this.btn.classList.add('is-loading');
    if (this.label) this.label.textContent = 'Adding the kit...';
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: lines })
    })
      .then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok) throw new Error(data.description || data.message || 'The kit could not be added.');
          return data;
        });
      })
      .then(function () { return fetch(root + 'cart.js').then(function (r) { return r.json(); }); })
      .then(function (cart) { return refreshCart(cart, 'sm-kits'); })
      .then(function () { self.say('Kit added to your cart.'); })
      .catch(function (err) { self.say(err && err.message ? err.message : 'The kit could not be added.', true); })
      .then(function () {
        self.btn.disabled = false;
        self.btn.classList.remove('is-loading');
        if (self.label) self.label.textContent = original;
      });
  };

  Kit.prototype.setColour = function (colour) {
    if (!colour) return;
    var want = String(colour).toLowerCase();
    var done = false;
    this.items.forEach(function (item) {
      if (done) return;
      item.selects.forEach(function (s) {
        if (done || !s.hasAttribute('data-colour-opt')) return;
        for (var i = 0; i < s.options.length; i++) {
          if (s.options[i].value.toLowerCase() === want) {
            s.value = s.options[i].value;
            done = true;
            break;
          }
        }
      });
    });
    this.update();
  };

  function kitFor(el) {
    if (!el) return null;
    if (!el.__smKit) el.__smKit = new Kit(el);
    return el.__smKit;
  }

  /* ---------- Temperature tabs ---------- */

  function initTabs(wrap) {
    if (wrap.__smTabs) return;
    wrap.__smTabs = true;
    var tabs = Array.prototype.slice.call(wrap.querySelectorAll('[role="tab"]'));
    function activate(tab, focus) {
      tabs.forEach(function (t) {
        var on = t === tab;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        var panel = document.getElementById(t.getAttribute('aria-controls'));
        if (panel) panel.hidden = !on;
      });
      if (focus) tab.focus({ preventScroll: true });
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { activate(t, false); });
      t.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        e.preventDefault();
        var next = tabs[(i + (e.key === 'ArrowRight' ? 1 : tabs.length - 1)) % tabs.length];
        activate(next, true);
      });
    });
    wrap.__smActivate = function (blockId) {
      var t = tabs.filter(function (x) { return x.getAttribute('data-block') === blockId; })[0];
      if (t) activate(t, false);
    };
  }

  /* ---------- Setup finder ---------- */

  function initFinder(el) {
    if (el.__smFinder) return;
    el.__smFinder = true;
    var steps = Array.prototype.slice.call(el.querySelectorAll('[data-step]'));
    var order = ['1', '2', '3', 'result'];
    var answers = {};
    var current = '1';
    var countEl = el.querySelector('[data-sm-finder-count]');
    var barEl = el.querySelector('[data-sm-finder-bar]');
    var backBtn = el.querySelector('[data-sm-finder-back]');
    var progress = el.querySelector('[data-sm-finder-progress]');
    var top = el.querySelector('[data-sm-finder-top]') || el;

    function show(step, scroll) {
      current = step;
      steps.forEach(function (s) { s.hidden = s.getAttribute('data-step') !== step; });
      var idx = order.indexOf(step);
      if (countEl) countEl.textContent = step === 'result' ? '3 of 3 answered' : 'Question ' + (idx + 1) + ' of 3';
      if (barEl) barEl.style.width = (step === 'result' ? 100 : ((idx + 1) / 3) * 100) + '%';
      if (backBtn) backBtn.hidden = step === '1';
      if (progress) progress.classList.toggle('is-done', step === 'result');
      if (step === 'result') renderResult();
      if (scroll) {
        var r = top.getBoundingClientRect();
        if (r.top < 0 || r.top > window.innerHeight * 0.4) {
          window.scrollTo({ top: window.scrollY + r.top - 90, behavior: 'smooth' });
        }
      }
    }

    function pick(btn) {
      var key = btn.getAttribute('data-answer');
      answers[key] = { id: btn.getAttribute('data-value'), colour: btn.getAttribute('data-colour') };
      Array.prototype.forEach.call(el.querySelectorAll('[data-answer="' + key + '"]'), function (b) {
        b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
      });
      var next = order[order.indexOf(btn.closest('[data-step]').getAttribute('data-step')) + 1];
      setTimeout(function () { show(next, true); }, 180);
    }

    function renderResult() {
      ['hunt', 'climate', 'terrain'].forEach(function (key) {
        Array.prototype.forEach.call(el.querySelectorAll('[data-result-' + key + ']'), function (node) {
          node.hidden = !answers[key] || node.getAttribute('data-result-' + key) !== answers[key].id;
        });
      });
      var climate = answers.climate && el.querySelector('[data-result-climate="' + answers.climate.id + '"] [data-sm-kit]');
      var kit = kitFor(climate);
      if (kit && answers.terrain) kit.setColour(answers.terrain.colour);
    }

    Array.prototype.forEach.call(el.querySelectorAll('[data-answer]'), function (btn) {
      btn.addEventListener('click', function () { pick(btn); });
    });
    if (backBtn) backBtn.addEventListener('click', function () {
      var idx = order.indexOf(current);
      if (idx > 0) show(order[idx - 1], true);
    });
    var restart = el.querySelector('[data-sm-finder-restart]');
    if (restart) restart.addEventListener('click', function () {
      answers = {};
      Array.prototype.forEach.call(el.querySelectorAll('[data-answer]'), function (b) { b.setAttribute('aria-pressed', 'false'); });
      show('1', true);
    });

    el.__smShowStepFor = function (blockId) {
      var node = el.querySelector('[data-block="' + blockId + '"]');
      var step = node && node.closest('[data-step]');
      if (step) show(step.getAttribute('data-step'), false);
    };
    show('1', false);
  }

  /* ---------- Boot ---------- */

  function init(scope) {
    scope = scope || document;
    Array.prototype.forEach.call(scope.querySelectorAll('[data-sm-kit]'), kitFor);
    Array.prototype.forEach.call(scope.querySelectorAll('[data-sm-tabs]'), initTabs);
    Array.prototype.forEach.call(scope.querySelectorAll('[data-sm-finder]'), initFinder);
  }

  window.SmKits = { init: init, kit: kitFor };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var section = e.target.closest('[id^="shopify-section-"]');
    if (!section) return;
    var tabs = section.querySelector('[data-sm-tabs]');
    if (tabs && tabs.__smActivate) tabs.__smActivate(e.detail && e.detail.blockId);
    var finder = section.querySelector('[data-sm-finder]');
    if (finder && finder.__smShowStepFor) finder.__smShowStepFor(e.detail && e.detail.blockId);
  });
})();
